//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Alert from "../Alert/Alert";
import GridElement from "../Layout/Grid/GridElement";
import Shadowable from "../../mixins/Shadowable";
import {formatDimension} from "../../helpers/format_helpers";
const Btn = () => import("../Button/Btn");
const Icon = () => import("../Icon/Icon");

export default {
    name: "MissingInfo",

    components: {Btn, Icon, Alert},

    mixins: [GridElement, Shadowable],

    props: {
        icon: {
            type: [String, Boolean],
            default: null
        },
        // The HTML content to render in the alert
        text: {
            type: String,
            default: null
        },
        // The text to display on a button to navigate the user to a corresponding creation page
        // or true to display the button with a default 'add' text
        button: {
            type: String | Boolean,
            default: null
        },
        // The route to navigate the user to when he clicks on the button
        to: {
            type: String | Object,
            default: null
        },

        buttonIcon: {
            type: [String, Boolean],
            default: null
        },

        color: {
            default: null
        },
        // Whether to prevent any border radius
        tile: {
            type: Boolean,
            default: false
        },

        // Whether to render the element as card
        card: {
            type: Boolean,
            default: false
        },

        minHeight: {
            type: [String, Number],
            default: null
        },

        // Whether to vertically align the content even on desktop devices
        vertical: {
            type: Boolean,
            default: false
        }
    },

    computed: {
        minHeightStyle() {
            return formatDimension(this.minHeight);
        }
    }
}
